import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'login-failed',
  // Deliberately self-contained: this page is reached specifically because
  // WellChron's own user context failed to load (see UserHydrationGuard), so
  // it must not depend on LoginService/HttpService or anything else that
  // assumes a hydrated user -- only the Auth0 SDK, so logging out always works.
  template: `
    <div class="d-flex flex-column align-items-center justify-content-center text-center"
         style="height: 100vh; padding: 2rem;">
      <h2>We couldn't sign you in to WellChron</h2>
      <p class="text-muted" style="max-width: 480px;">
        Your Enverus account may not have been granted access to WellChron yet, or something
        went wrong loading your profile. Contact your WellChron administrator if you believe
        this is a mistake.
      </p>
      <button type="button" class="btn btn-primary mt-3" (click)="logout()">Log out</button>
    </div>
  `,
  standalone: false
})
export class FailedComponent {
  constructor(private authService: AuthService) { }

  logout(): void {
    this.authService.logout({
      logoutParams: { returnTo: window.location.origin },
    });
  }
}
